import PostOnboardingDashboardTasks from "mfe/PostOnboardingDashboardTasks/PostOnboardingDashboardTasks";
import { useParams } from "react-router";

const PostOnboardingPreviewPage = () => {
    const params = useParams();
    const propertyId = Number(params.propertyId);

    return <PostOnboardingDashboardTasks propertyId={Number.isFinite(propertyId) ? propertyId : undefined} />;
};

export default PostOnboardingPreviewPage;
